import { Component, Element, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import { parseAttribute } from '../../utils';
import { MenuItemGroup, NOTIFICATION_TYPE, NotificationLinks } from '../login-flyout/exports';
import { LANGUAGE, LOGIN_SIZES, LOGIN_STATE, LOGIN_TYPE } from './exports';

@Component({
  tag: 'mdx-login',
  styleUrl: 'login.scss',
  shadow: true,
})
export class Login {
  @Element()
  host: HTMLMdxLoginElement;

  @Prop({ reflect: true })
  size: (typeof LOGIN_SIZES)[keyof typeof LOGIN_SIZES] = LOGIN_SIZES.SM;

  @Prop({ reflect: true })
  state: (typeof LOGIN_STATE)[keyof typeof LOGIN_STATE] = LOGIN_STATE.LOGGED_OUT_WITH_BUTTON;

  @Prop({ reflect: true })
  language: (typeof LANGUAGE)[keyof typeof LANGUAGE] = LANGUAGE.DE;

  @Prop({ reflect: true })
  dark: boolean = false;

  @Prop()
  notification: boolean = false;

  @Prop({ reflect: true })
  type: (typeof LOGIN_TYPE)[keyof typeof LOGIN_TYPE] = LOGIN_TYPE.NEUTRAL;

  @Prop({ reflect: true })
  notificationType: (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE] = NOTIFICATION_TYPE.NONE;

  @Prop()
  userProfileName: string = '';

  @Prop()
  userProfileEmail: string = '';

  @Prop()
  accountUrl: string = '';

  @Prop()
  menuItemGroup: MenuItemGroup[] = [];

  @Prop()
  notificationLinks?: NotificationLinks;

  @Prop()
  profileImageUrl?: string;

  @Prop()
  profileImageAlt?: string;

  @Prop()
  loginAvatarArialabel!: string;

  @State()
  flyoutOpen: boolean = false;

  @Event()
  login: EventEmitter<void>;

  @Event()
  logout: EventEmitter<void>;

  private getInitials() {
    return this.userProfileName
      .trim()
      .split(' ')
      .filter((_, i, arr) => i === 0 || i === arr.length - 1)
      .map(([C]) => C.toUpperCase())
      .join('');
  }

  private getComponent() {
    switch (this.state) {
      case LOGIN_STATE.LOGGED_IN_WITH_AVATAR:
        return (
          <mdx-login-avatar
            size={this.size}
            loginAvatarArialabel={this.loginAvatarArialabel}
            dark={this.dark}
            profileImageUrl={this.profileImageUrl}
            profileImageAlt={this.profileImageAlt}
            isLoggedIn={true}
            onClick={() => (this.flyoutOpen = !this.flyoutOpen)}
            notification={this.notification}
          ></mdx-login-avatar>
        );
      case LOGIN_STATE.LOGGED_OUT_WITH_BUTTON:
        return (
          <mdx-login-button
            size={this.size}
            dark={this.dark}
            type={this.type}
            language={this.language}
            onClick={() => this.login.emit()}
          ></mdx-login-button>
        );
      case LOGIN_STATE.LOGGED_IN_WITH_INITIALS:
        return (
          <mdx-login-avatar
            size={this.size}
            loginAvatarArialabel={this.loginAvatarArialabel}
            dark={this.dark}
            userInitials={this.getInitials()}
            isLoggedIn={true}
            onClick={() => (this.flyoutOpen = !this.flyoutOpen)}
            notification={this.notification}
          ></mdx-login-avatar>
        );
      case LOGIN_STATE.LOGGED_OUT_WITH_AVATAR:
        return (
          <mdx-login-avatar
            size={this.size}
            loginAvatarArialabel={this.loginAvatarArialabel}
            dark={this.dark}
            isLoggedIn={false}
            onClick={() => this.login.emit()}
          ></mdx-login-avatar>
        );
    }
  }

  render() {
    return (
      <div class="login">
        <span class="login__component">{this.getComponent()}</span>
        <mdx-login-flyout
          open={this.flyoutOpen}
          onLogout={() => this.logout.emit()}
          onClose={() => (this.flyoutOpen = false)}
          dark={this.dark}
          language={this.language}
          userProfileEmail={this.userProfileEmail}
          userProfileName={this.userProfileName}
          accountUrl={this.accountUrl}
          menuItemGroup={parseAttribute(this.host, 'menu-item-group', this.menuItemGroup)}
          notificationLinks={parseAttribute(this.host, 'notification-links', this.notificationLinks)}
          notificationType={this.notificationType}
        ></mdx-login-flyout>
      </div>
    );
  }
}
